import { useGoBack } from '@/common/hooks/useGoBack'
import { ChevronLeftIcon } from 'lucide-react'
import { twMerge } from 'tailwind-merge'
import Button from '../Button'

export interface GoBackButtonProps {
  fallback?: string
  searchLastRouteFromFallback?: boolean
  searchLastRouteIgnoringFilters?: boolean
  removeFilters?: boolean
  buttonClassName?: string
  iconClassName?: string
  dataTestid?: string
}

/**
 *
 * @param searchLastRouteFromFallback
 *  * ex:
 * current route -> /users/123/actions
 * fallback -> "/users"
 * return (navigate to) => /users?search=123
 *
 *
 * @param searchLastRouteIgnoringFilters
 *  * ex:
 * current route -> /establishment-bills/456
 * previous route -> /establishments/123/bills?search=456
 * return (navigate to) =>  /establishments/123/bills?search=456
 *
 *  * ex:
 * current route -> /establishment-bills/456
 * previous route -> /establishment-bills?search=456
 * return (navigate to) => /establishment-bills?search=456
 *
 *  * ex:
 * current route -> /users/123/actions
 * previous route -> /users/123
 * return (navigate to) => /users/123
 *
 */

const GoBackButton = ({
  fallback,
  searchLastRouteFromFallback,
  searchLastRouteIgnoringFilters,
  removeFilters,
  buttonClassName,
  iconClassName,
  dataTestid,
}: GoBackButtonProps) => {
  const goBack = useGoBack()

  return (
    <Button
      variant="link-white"
      name={dataTestid ? dataTestid : 'go_back'}
      onClick={() => goBack({ fallback, searchLastRouteFromFallback, searchLastRouteIgnoringFilters, removeFilters })}
      className={twMerge('cursor-pointer', buttonClassName)}
    >
      <ChevronLeftIcon size={40} strokeWidth={1} className={iconClassName} />
    </Button>
  )
}

export default GoBackButton
